import { Link, Navigate, useNavigate, useSearchParams } from 'react-router'
import { useEffect } from 'react'
import { safeNext } from '../lib/analytics'
import { Button, Card, Skeleton } from '../ui'
import { useSession } from '../lib/session'
import { Page } from './Page'
import styles from './AccountPage.module.css'

export function AccountPage() {
  const { me, signOut } = useSession()
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const next = safeNext(params.get('next'))
  // Already signed in (or just signed in): continue to where the visitor was heading.
  useEffect(() => { if (me && next) navigate(next, { replace: true }) }, [me, next, navigate])
  // Signed out: the dedicated sign-in page (old /account?signup=1&next=… links keep working).
  if (me === null) {
    const p = new URLSearchParams(params)
    if (!p.has('next')) p.set('next', '/account')
    return <Navigate to={`/login?${p.toString()}`} replace />
  }
  return (
    <Page title="Account">
      {me === undefined && <Card><Skeleton lines={3} label="Loading account" /></Card>}
      {me && (
        <Card title="Your account">
          <dl className={styles.dl}>
            <dt>Email</dt><dd>{me.user.email}</dd>
            <dt>Plan</dt><dd>{me.plan.name}{me.plan.status !== 'active' ? ` (${me.plan.status})` : ''} · <Link to="/billing">Billing and invoices</Link>{me.promo?.active ? ' · launch offer: everything in Trader, free' : me.plan.code === 'free' ? <> · <Link to="/pricing">Upgrade</Link></> : null}</dd>
            <dt>Role</dt><dd>{me.user.role === 'admin' ? 'Admin' : 'Member'}</dd>
            <dt>Filings delay</dt><dd>{Number(me.entitlements.filings_delay_minutes ?? 0) > 0 ? `${String(me.entitlements.filings_delay_minutes)} minutes` : 'Real time'}</dd>
          </dl>
          <Button onClick={() => void signOut()}>Sign out</Button>
        </Card>
      )}
    </Page>
  )
}
